import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'

const CarRepair = ({ globalData }) => {
    return (
        <Container>
            <Row>
                <Col md={12} className="mt-2">

                    <div className="content-main-div">
                        <h1 className="content-heading">
                            Expert Car Repair Services for All Models: Trust Our Skilled Mechanics to Restore Your Vehicle's Performance
                        </h1>
                        <p className="content-paragraph">Car repairs are a necessary part of owning a vehicle. Whether it's routine maintenance or unexpected repairs, keeping your car in good working order is essential for both your safety and the longevity of your vehicle.
                        </p>
                        <p className="content-paragraph">At Open Bonnet, we understand that car repairs can be stressful and time-consuming. That's why we've created a fully digitized experience that connects car owners with verified service providers, making the process of getting your car repaired as convenient and transparent as possible.
                        </p>
                        <p className='content-paragraph'>
                            Our team carefully vetted them to ensure that they meet our high standards for quality and professionalism. They have the expertise and experience necessary to perform a wide range of repairs, from routine maintenance to more complex repairs.
                        </p>
                        <h4 className="content-sub-heading">Choose Your Right Fit Service- For everything that isn’t covered elsewhere, get Open Bonnet car repair services-
                        </h4>
                        <ul className="content-list mobile-content-list">
                            <li>Steering Repair</li>
                            <li>Underbody/ Suspension</li>
                            <li>Gear/ Transmission</li>
                            <li>Axle/ Shocks & Mounts</li>
                            <li>Not Sure - Help Me Out</li>
                            <li><a className='paragraph-link' href={`/services/${globalData.locationData?.data?.EmirateAreaSlug ||
                                "dubai"
                                }/ac-service`}>AC service and repair</a></li>
                            <li>Denting/ Painting</li>
                            <li>Brakes</li>
                            <li>Electrical/ Warning Lights</li>
                            <li>Engine</li>
                        </ul>
                        <p className="content-paragraph">Regular oil changes are essential to keep your car's engine in good condition. By changing the oil, you remove the dirt and debris that build up over time and replace it with clean oil. This helps to reduce friction and wear on the engine, which can cause damage and decrease its lifespan. Additionally, fresh oil improves your car's fuel efficiency, reduces emissions, and helps to maintain optimal engine performance.
                        </p>

                        <h4 className="content-sub-heading">Warranty on Car Repair:</h4>
                        <p className='content-paragraph'>
                            At Open Bonnet, we understand that car repairs can be expensive and time-consuming. That's why we offer a comprehensive warranty on all car repairs performed through our platform. Our warranty covers all parts and labor for a period after the repair is completed.
                        </p>
                        <h4 className="content-sub-heading">About Car Wash And Spa at Open Bonnet:</h4>
                        <p className='content-paragraph'>
                            At Open Bonnet, we are committed to providing our customers with the highest quality car washing and spa services. Our team of experts is dedicated to delivering an unparalleled experience that is both convenient and affordable. We use the latest technology and equipment to provide you with the best results possible. With our fully digitized platform, you can easily book your car wash or spa service from the comfort of your home. Trust us to take care of your car, and we promise to exceed your expectations every time.

                        </p>

                    </div>

                </Col>
            </Row>
        </Container >
    )
}

export default CarRepair
